import { useCallback } from "react";
import { useWavyTextAnimation } from "../ui/useWavyTextAnimation";

interface UseWheelDialogOptions {
  isOpen: boolean;
  onClose: () => void;
  /** Whether the spin has completed */
  hasSpun: boolean;
}

/**
 * Hook for managing wheel dialog behavior
 * Handles scroll blocking, animations, and cleanup
 */
export const useWheelDialog = ({ isOpen, onClose, hasSpun }: UseWheelDialogOptions) => {
  // Wavy text animation for title
  const { textElementRef: animatedTitleRef } = useWavyTextAnimation({
    isActive: isOpen && !hasSpun,
    text: "Spin the Wheel!",
    startDelay: 200,
    letterDelay: 60,
  });

  // Handle dialog close with cleanup
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return {
    animatedTitleRef,
    handleClose,
  };
};
